import About from "../components/commands/About";
import Bio from "../components/commands/Bio";
import Contact from "../components/commands/Contact";
import Help from "../components/commands/Help";
import NotFound from "../components/commands/NotFound";
import Skills from "../components/commands/Skills";
import Project from "../components/commands/Project";
import { CmdHistory } from "../type";

function renderCmd(cmd: string): CmdHistory {
	switch (cmd) {
		case "help":
			return {
				cmd,
				Component: Help,
				time: "",
			};
		case "cat bio":
			return {
				cmd,
				Component: Bio,
				time: "",
			};
		case "cat skill":
			return {
				cmd,
				Component: Skills,
				time: "",
			};
		case "cat contact":
			return {
				cmd,
				Component: Contact,
				time: "",
			};
		case "cat about":
			return {
				cmd,
				Component: About,
				time: "",
			};
		case "cat project":
			return {
				cmd,
				Component: Project,
				time: "",
			};
		default:
			return {
				cmd,
				Component: NotFound,
				time: "",
			};
	}
}

export default renderCmd;
